const headers = {
  name: "Lpo Order",
  navigate: {
    path: [
      {
        name: "Orders",
        path: "/app/purchases",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
